import Image from "@components/core/Image";

function ReferralTriptychCard({ card }) {
  const { title, content, imgName, imgAlt } = card;

  return (
    <div
      className="w-100 px-3 pb-3"
      style={{ maxWidth: "360px" }}
    >
      <div
        style={{ height: "80px" }}
        className="mb-4"
      >
        <Image
          src={imgName}
          className="h-100"
          alt={imgAlt}
        />
      </div>

      <h5 className="mb-3">{title}</h5>

      <p className="mb-0">{content}</p>
    </div>
  );
}

export default ReferralTriptychCard;
